import axios from 'axios';

const API = import.meta.env.VITE_API_URL || 'https://cuvia.ro/api';

const auth = (token) => ({
  headers: { Authorization: `Bearer ${token}` }
});

const formAuth = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'multipart/form-data'
  }
});

/* ================= PUBLIC ================= */

export const getAllProperties = () =>
  axios.get(`${API}/properties`).then(r => r.data);

export const getPropertyById = (id) =>
  axios.get(`${API}/properties/${id}`).then(r => r.data);

/* ================= HOST ================= */

export const createProperty = (payload, token) =>
  axios.post(`${API}/host/properties`, payload, auth(token)).then(r => r.data);

export const updateProperty = (id, payload, token) =>
  axios.put(`${API}/host/properties/${id}`, payload, auth(token)).then(r => r.data);

export const deleteProperty = (id, token) =>
  axios.delete(`${API}/host/properties/${id}`, auth(token)).then(r => r.data);

export const uploadPropertyImages = (id, formData, token) =>
  axios.post(`${API}/properties/${id}/images`, formData, formAuth(token))
       .then(r => r.data);

export const deletePropertyImage = (propertyId, imageId, token) =>
  axios.delete(
    `${API}/properties/${propertyId}/images/${imageId}`,
    auth(token)
  ).then(r => r.data);

export const getHostProperties = (token) =>
  axios.get(`${API}/host/properties`, auth(token)).then(r => r.data);
